import { global } from ":shared/app";
import { ENDPOINTS } from "./enpoints";

export async function get_issue_types() {
  return global.api
    .getAuth(ENDPOINTS.issue_types)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.reject(err.message);
    });
}
